export default {
	people: {
		title: "Personnes",
	},
	spiritualManagement: {
		title: "Gestion spirituelle",
	},
	ritualManagement: {
		title: "Gestion des rituels",
	},
	templeManagement: {
		title: "Gestion du temple",
	},
	tools: {
		title: "Outils",
	},
};
